import Vue from 'vue'
import Router from 'vue-router'
import master from '@/pages/master/index'
import release from '@/pages/release/index'
import sub_res from '@/pages/release/sub_res/index'
import interview from '@/pages/interview/index'
import mine from '@/pages/mine/index'
import login from '@/pages/login/index'
import expert_info from '@/pages/expert/expert_info/index'
import expert_all from '@/pages/expert/expert_all/index'
import article_info from '@/pages/article_info/index'
import article_comment from '@/pages/article_comment/index'
import me from '@/pages/mine/me/index'
import advice from '@/pages/mine/advice/index'
import question from '@/pages/mine/question/index'
import action from '@/pages/mine/action/index'
import follow from '@/pages/mine/follow/index'
import collection from '@/pages/mine/collection/index'
import customer from '@/pages/mine/customer/index'
import share from '@/pages/mine/share/index'
import setting from '@/pages/mine/setting/index'
import shezhi from '@/pages/mine/shezhi/index'
import search from '@/pages/search/index'
import topic from '@/pages/topic/index'

// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '*',
    },
    {
      path: '/',
      redirect: '/master',
    },
    //登陆
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        keepAlive: false,
        isTab: false,
      }
    },
    //首页
    {
      name: 'master',
      path: '/master',
      component: master,
      meta: {
        keepAlive: true,
        isTab: true,
      }
    },
    //搜索
    {
      path: '/search',
      component: search,
      meta: {
        keepAlive: true,
        isTab: false,
      }
    },
    //搜索
    {
      path: '/shezhi',
      component: shezhi,
      meta: {
        keepAlive: true,
        isTab: false,
      }
    },
    //发布
    {
      path: '/release',
      component: release,
      meta: {
        keepAlive: false,
        isTab: true,
      }
    },
    //发布成功
    {
      path: '/sub_res',
      component: sub_res,
      meta: {
        keepAlive: false,
        isTab: false,
      }
    },
    //访谈
    {
      path: '/interview',
      component: interview,
      meta: {
        keepAlive: false,
        isTab: true,
      }
    },
    //我的
    {
      path: '/mine',
      component: mine,
      meta: {
        keepAlive: false,
        isTab: true,
      }
    },
    //专家详情
    {
      path: '/expert_info/:expert_id',
      component: expert_info,
      meta: {
        keepAlive: false,
        isTab: false,
      }
    },
    //全部专家
    {
      path: '/expert_all',
      component: expert_all,
      meta: {
        keepAlive: false,
        isTab: false,
      }
    },
    //文章详情
    {
      name: 'article_info',
      path: '/article_info/:article_id',
      component: article_info,
      meta: {
        keepAlive: false,
        isTab: false,
      }
    },
    //热门评论
    {
      path: '/article_comment/:comment_id',
      component: article_comment,
      meta: {
        keepAlive: false,
        isTab: false,
      }
    },
    //个人信息
    {
      path: '/me',
      component: me,
      meta: {
        keepAlive: false,
        isTab: false,
      }
    },
    //反馈建议
    {
      path: '/advice',
      component: advice,
      meta: {
        keepAlive: false,
        isTab: false,
      }
    },
    //常见问题
    {
      path: '/question',
      component: question,
      meta: {
        keepAlive: false,
        isTab: false,
      }
    },
    //我的动态
    {
      path: '/action',
      component: action,
      meta: {
        keepAlive: false,
        isTab: false,
      }
    },
    //我的关注
    {
      path: '/follow',
      component: follow,
      meta: {
        keepAlive: false,
        isTab: false,
      }
    },
    //我的收藏
    {
      path: '/collection',
      component: collection,
      meta: {
        keepAlive: false,
        isTab: false,
      }
    },
    //我的客服
    {
      path: '/customer',
      component: customer,
      meta: {
        keepAlive: false,
        isTab: false,
      }
    },
    //分享推广
    {
      path: '/share',
      component: share,
      meta: {
        keepAlive: false,
        isTab: false,
      }
    },
    //设置
    {
      path: '/setting',
      component: setting,
      meta: {
        keepAlive: false,
        isTab: false,
      }
    },
    //主题
    {
      path: '/topic',
      component: topic,
      meta: {
        keepAlive: false,
        isTab: false,
      }
    },
  ],
  mode: 'history',
  base: '',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})
router.beforeEach((to, from, next) => {
  window.history.replaceState(null, null, window.location.href);
  next();
})
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js